import { CONSTANTS__client } from '@/constants/CONSTANTS__client';
import { use_slice_grid2d, use_slice_search } from '@/hooks/store/use_slices';
import { GRID2D__float } from '@/pages/_base/grid2d/views/GRID2D__float';
import { DTO__grid2d } from '@shared/dto/grid2d/DTO__grid2d';
import { useMemo } from 'react';
import { WatcherGetGrid2dSearchCurrent } from '../../watchers/grid2d/WatcherGetGrid2dSearchCurrent';

export function ViewGrid2dSearchCurrent() {
  const { search_current } = use_slice_search(['search_current']);
  const { grids2d_map } = use_slice_grid2d(['grids2d_map']);

  const grid2d = useMemo(() => get_grid2d(), [search_current, grids2d_map]);

  /*
   * METHODS
   */
  function get_grid2d() {
    //wait for load grid from server
    if (!grids2d_map.has(search_current._id)) return DTO__grid2d.CREATE_STUB();

    let out = grids2d_map.get_or_assert(search_current._id);

    return out.clone();
  }

  return (
    <>
      <WatcherGetGrid2dSearchCurrent />
      <div className={`w-full p-[1px] bg-component`} style={{ height: `calc(100% - ${CONSTANTS__client.TOPBAR_HEIGHT}px)` }}>
        <GRID2D__float grid2d={grid2d} entity={search_current} />
      </div>
    </>
  );
}
